import { render, staticRenderFns } from "./timHome.vue?vue&type=template&id=5067d26e&scoped=true&"
import script from "./timHome.vue?vue&type=script&lang=js&"
export * from "./timHome.vue?vue&type=script&lang=js&"
import style0 from "./timHome.vue?vue&type=style&index=0&id=5067d26e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5067d26e",
  null
  
)

export default component.exports